<template>
  <v-slide-y-transition mode="out-in">
    <div style="width: 100%; height: 100%; z-index: 0">
      <div id="trackmap" style="width: 100%; height: 100%; z-index: 0;"></div>

      <!--<v-btn
        label
        absolute
        dark
        top
        right
        color="cyan"
        large
        app
        style="margin-top: 110px;margin-right: -18px"
        @click=""
      >
        <v-icon>add</v-icon>
      </v-btn>-->

      <v-btn
        absolute
        dark
        fab
        bottom
        right
        color="pink"
        app
        style="margin-bottom: 20%"
        @click="toggleTracking"
      >
        <v-icon>{{isTracking?'pause':'play_arrow'}}</v-icon>
      </v-btn>

      <v-navigation-drawer
        temporary
        :right="right"
        v-model="rightDrawer"
        :clipped="clipped"
        fixed
        app
        :width="200"
      >
        <v-subheader>{{Object.keys(color).length}} trucks, pls select one</v-subheader>
        <!--<v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title></v-list-tile-title>
        </v-list-tile>-->

        <v-container fluid style="padding-top: 0">
          <v-layout row wrap>
            <div class="flex xs12">
              <div role="radiogroup"
                   class="input-group input-group--async-loading input-group--dirty input-group--hide-details radio-group radio-group--column"
                   style="padding: 0px 0px 0px 15px;"
                   v-for="(value, key,index) in color "
              >
                <div class="input-group__input">
                  <div role="radio" aria-checked="false" :aria-label="'Truck '+key"
                       class="input-group input-group--selection-controls radio input-group input-group--active input-group--selection-controls radio"
                       :tabindex="index" :style="{color:value }"
                  >
                    <label :style="{color:value }"
                           v-bind:for="'input_'+index"
                           @click="onCheck($event,key,index)"
                    >Truck {{key}} </label>
                    <div class="input-group__input"
                         @click="onCheck($event,key,index)"
                    >
                      <i v-bind:ref="'i_'+index"
                         aria-hidden="true"
                         class="icon icon--selection-control material-icons"

                      >{{(targetTruckIndex==index)?'radio_button_checked':'radio_button_unchecked'}}</i>
                      <div class="input-group--selection-controls__ripple"></div>
                      <!--<input
                        type="radio"
                        v-bind:id="'input_'+index"
                        v-bind:value="key"
                        v-model="targetTruck"
                        style="display: none;"
                        @click="onInputCheck($event,key,index)"
                      >-->
                    </div>
                  </div>
                </div>
                <div class="input-group__details">
                  <div class="progress-linear" style="height: 2px;">
                    <div class="progress-linear__background true" style="height: 2px; opacity: 0.3; width: 100%;"></div>
                    <div class="progress-linear__bar">
                      <div class="progress-linear__bar__indeterminate progress-linear__bar__indeterminate--active">
                        <div class="progress-linear__bar__indeterminate long true"></div>
                        <div class="progress-linear__bar__indeterminate short true"></div>
                      </div><!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--<v-flex xs12>
              <v-radio-group loading="true" v-model="targetTruck" column v-for="(value, key) in color " hide-details
                             style="padding: 0px 0px 0px 15px">
                <v-radio
                  :label="'Truck '+key"
                  :value="key"
                  v-bind:style="{ color: value}"
                  v-bind:class="['input-group','input-group&#45;&#45;active','input-group&#45;&#45;selection-controls','radio']"

                ></v-radio>

              </v-radio-group>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-navigation-drawer>

    </div>
  </v-slide-y-transition>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
  import dataArr from '@/assets/js/data.js';
  import eventBus from '../EventBus.js';

  export default {
    name: 'DashBoard',
    data: function () {
      return {
        isTracking:true,
        right: true,
        rightDrawer: false,
        clipped: true,


        color: {},
        baseDataPos: 0,
        curPos: 0,
        maxPos: 0,
        allPointHandler: [],
        curBatchOfHandler: [],
        lastPointHanlder: undefined,
        lastLineHandler: undefined,
        targetTruck: '',
        targetTruckIndex: -1,
        lastHandlerOfEachTruck: {},
        circleSize: 5,
        truckZoomLevel: 17

      }
    },
    activated:function () {
      eventBus.$emit('showbtn');
    },
    deactivated:function () {
      eventBus.$emit('hidebtn');
    },
    created: function () {
      var self = this
      var options = {
        minOpacity: 0.1,
        maxZoomL: 20,
        max: 1.0,
        radius: 5,
        blur: 12
      }
      //this.layer = L.esri.basemapLayer('Gray');

      self.showRightDrawerBtn()
      self.layer = L.esri.basemapLayer("Topographic");
      self.markersLayer = L.markerClusterGroup({
        disableClusteringAtZoom: self.truckZoomLevel,
        spiderfyOnMaxZoom: false
      });

      self.splitData()
      this.buildColor(0, self.baseDataPos)


      eventBus.$on('toggle_right_drawer', function () {
        self.rightDrawer = !self.rightDrawer
      });
    },
    methods: {
      toggleTracking:function () {
        this.isTracking=!this.isTracking
      },

      showRightDrawerBtn: function () {
        eventBus.$emit('showbtn');
      },

      setupRandomTruck: function () {
        var self = this;
        var carArr = Object.keys(self.color);
        var len = carArr.length
        var randNum = Math.floor(Math.random() * (len))
        self.targetTruck = carArr[randNum]
      },

      onCheck: function (e, key, index) {
        this.selectNewTarget();
        this.targetTruck = key
        this.targetTruckIndex = index
        this.rightDrawer = false
      },
      buildColor: function (start, end) {
        var self = this
        var dataList = dataArr, name;
        for (var i = start; i < end; i++) {
          name=dataList[i][0];
          if(!(self.color[name])){
            self.color[name] = self.getRandomColor()

          }
        }
      },
      getRandomColor: function () {
        return "#" + Math.floor(Math.random() * 16777215).toString(16);
      },
      splitData: function () {
        var len = Math.floor(dataArr.length / 2);
        var pos = Math.floor((len - 2) * (Math.random())) + 1;
        this.baseDataPos = pos;
        this.curPos = pos;
        this.maxPos = len;
      },
      addBasePoints: function (map) {
        var start = Date.now();
        var self = this;
        var dataList = dataArr;
        var item;
        for (var i = 0, len = self.baseDataPos; i < len; i++) {
          item = dataList[i]
          self.addPoint(item, self.markersLayer)
          //self.allPointHandler.push(self.addPoint(item, self.markersLayer))
        }
      },
      addMultiPoints: function (start, end, map) {
        var self = this;
        var item;
        //var curBatchOfHandler = [];
        var handler;
        for (var i = start; i < end; i++) {
          item = dataArr[i]
          handler = self.addPoint(item, map)
          handler
          //curBatchOfHandler.push()
        }
        //return curBatchOfHandler;
      },
      addPoint: function (item, map) {
        var self = this;
        var name = item[0];
        //console.log('name='+name+', color='+self.color[name])
        var date = item[1];
        var activity = item[2];
        var lat = item[3];
        var lng = item[4];
        var handler = L.circleMarker([lat, lng], {
          radius: self.circleSize,
          color: self.color[name]
        }).bindPopup("Trucker Name: " + name + '<br>'
          + "Time: " + date + '<br>'
          + "Activity Type: " + activity + '<br>'
          + "latitude: " + lat + '<br>'
          + "longitude: " + lng + '<br>'
        ).addTo(map);
        self.lastHandlerOfEachTruck[name] = handler;
        return handler;
      },
      getNewData: function () {
        var self = this;
        var start = self.curPos;
        var end = start + 1;
        if (end >= self.maxPos) {
          end = self.maxPos
        }
        self.curPos = end
        return [start, end]
      },

      cancelRaf: function () {
        cancelAnimationFrame(self.raf)
        self.raf = undefined
      },
      gotoLastPoint: function () {

        var self = this;
        //console.log(self.targetTruck)
        var lastHandler = self.lastHandlerOfEachTruck[self.targetTruck];
        if (!lastHandler) {
          return
        }

        var latlng = lastHandler.getLatLng()
        self.changeLastPointStatus(lastHandler)
        if(self.isTracking) {
          self.map.panTo([latlng.lat, latlng.lng])
        }
      },
      changeLastPointStatus: function (handler) {
        var self = this
        var lastPointHanlder = self.lastPointHanlder
        if (lastPointHanlder) {
          lastPointHanlder.setRadius(self.circleSize)
        }
        handler.setRadius(15)
        self.addLine(lastPointHanlder, handler)
        self.lastPointHanlder = handler
      },
      addLine: function (lastPointHanlder, handler) {
        if (this.lastLineHandler) {
          this.map.removeLayer(this.lastLineHandler)
        }
        if ((!lastPointHanlder) || (!handler)) {
          return
        }
        var lastLatlng = lastPointHanlder.getLatLng()
        var latlng = handler.getLatLng()
        this.lastLineHandler = L.polyline([[lastLatlng.lat, lastLatlng.lng], [latlng.lat, latlng.lng]], {color: 'red'}).addTo(this.map);
      },

      selectNewTarget: function () {
        var self = this
        var lastPointHanlder = self.lastPointHanlder
        //立即恢复原有大小，以及清除记录
        if (lastPointHanlder) {
          lastPointHanlder.setRadius(self.circleSize)
        }
        self.lastPointHanlder = undefined

        //删除趋势线
        this.lastLineHandler
        if (this.lastLineHandler) {
          this.map.removeLayer(this.lastLineHandler)
        }

        //zoom
        this.map.setZoom(self.truckZoomLevel)

        // 跟踪
        self.isTracking=true;

      },
      streaming: function (map) {
        var self = this;
        var maxPos = self.maxPos;
        if (self.raf) {
          self.cancelRaf()
          return
        } else {
          loop();
        }
        var isFirstTime = true

        function loop() {
          self.raf = setTimeout(function (time) {
            if (self.curPos >= maxPos) {
              //self.cancelRaf()
              clearTimeout(self.raf)
              return
            }
            var startEnd = self.getNewData();
            var start = startEnd[0]
            var end = startEnd[1]
            // 可能会增加新车辆
            self.buildColor(start, end);

            self.addMultiPoints(start, end, map);
            ///self.allPointHandler = self.allPointHandler.concat();
            self.gotoLastPoint()
            if (isFirstTime) {
              setTimeout(function () {
                self.selectNewTarget()
                isFirstTime=false
              }, 1020)
            }
            loop();
          }, 1000)
        }

      }
    },
    mounted: function () {
      var self = this


      var lat = 43.03, lng = -76.14;


      var map = L.map('trackmap', {
        center: new L.LatLng(lat, lng),
        zoom: 13,
        layers: [self.layer, self.markersLayer],
        renderer: L.canvas()
      });

      self.map = map;
      self.addBasePoints(map)

      self.setupRandomTruck()
      self.streaming(map)

    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Tracker.vue